import React from 'react';
import {ScrollRestoration} from "react-router-dom";
import {Navbar} from "../navbar/navbar";
import {Footer} from "../footer/footer";
import FundraiserBanner from "../fundraiser-banner/fundraiser-banner";

const PageWrapper = ({ children }) => {
    return (
        <>
            <Navbar />
            <FundraiserBanner />
            <div style={{ marginTop: '160px' }}>
                {children}
            </div>
            <ScrollRestoration />
            <Footer />
        </>
    );
};

export default PageWrapper;